import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@material-ui/core';
import Rest from "../../../../services/Rest";
import Archive from '@material-ui/icons/Archive';

// tslint:disable-next-line:no-empty-interface
export interface IAdminImportPartnerDataProps {
}

export interface IAdminImportPartnerDataState {
  dialogOpen: boolean
}

export class AdminImportPartnerData extends React.Component<IAdminImportPartnerDataProps, IAdminImportPartnerDataState> {
  constructor(props: IAdminImportPartnerDataProps) {
    super(props);
    this.state = {
      dialogOpen: false
    }
}

    public render() {
        return  <div className="filter-item">
            <IconButton
                ia-owns={open ? 'simple-popper' : null}
                aria-haspopup="true"
                onClick={this.handleDialogOpen}
                color="inherit"
                aria-label="Menu Apps"
                className="menu-icon-bar">
                <Archive />
            </IconButton>

            <Dialog
                open={this.state.dialogOpen}
                onClose={this.handleDialogClose}
                aria-labelledby="economic-group-dialog-title"
                aria-describedby="alereconomic-group-dialog-description"
                className="filter-dialog"
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{"Importação de dados de parceiros"}</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Deseja iniciar o processo de importação dados de venda dos parceiros?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleDialogClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={this.importData} color="primary" autoFocus={true}>
                        Confirmar
                    </Button>
                </DialogActions>
                
            </Dialog>
        </div>
    }


    private importData = () => {
        this.handleDialogClose();
        Rest.POST('importPartnerData', {});
    }

    private handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    private handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };
}



// WEBPACK FOOTER //
// ./src/component/shared/admin/partnerData/AdminImportPartnerData.tsx